<!--
--------
@修改人：黄志杰
@修改时间：2018-11-2
@修改描述：新框架迁移
@版本: v2.0.0
--------
@修改人：谢汉
@修改时间：2018-04-26
@修改描述：新需求增加ASS OSS...分组
@版本:v1.0.16
--------
@负责人: 邱凤云
@创建时间: 2018-01-18
@版本:v1.0.12
@描述: 数据配置首页组件
@使用方法:
用于数据配置首页和view页面展示数据
    
@参数说明:
是否显示删除按钮
isDelete: {
  type: Boolean,
  default:true
},
是否显示添加按钮
isAdd: {
  type: Boolean,
  default: true
},
-->
<style scoped>
  .data-wrapper  {
    min-width: 500px;
  }
  .data-wrapper  input {
    padding-left: 24px;
    width: 240px;
  }
  .data-wrapper .datasource-group {
    font-weight: bolder;
    font-size: 17px;
  }
  .data-edit-default-wrap {
    margin-bottom: 30px;
    margin-top: 10px;
    vertical-align: middle;
  }
</style>
<template>
  <div class="content-wrap data-wrapper">
    <el-form ref="form" :model="form" :inline="true" input-width="auto">
      <el-form-item :label="$t('logComponentManage.site')">
        <g-select :list="siteList" v-model="form.siteCode"></g-select>
      </el-form-item>
      <el-form-item >
        <el-input 
          v-model="form.sourceName" 
          prefix-icon="uk-icon-search" 
          :placeholder="$t('component.sourceGroupInput')"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" 
          @click="addSource"
          v-g-rac="gRac('dataConfig_add') && isAdd"
          v-text="$t('common.add')"></el-button>
      </el-form-item>
    </el-form>    
      <div class="data-edit-default-wrap vm" v-for="(item, iindex) in sourceData" v-bind:key="iindex">
        <div class="datasource-group" v-text="item.name"></div>
        <div style="height: 140px;" class="com-box__wrap"
          v-bind:key="index"
          v-for="(items, index) in item.list"
          @click="chooseSource(items, item.name)"
          :title="items.name ? items.name : items.desc">
          <i v-show="isDelete && item.name === $t('component.sourceGroupOther')" class="com-box__delete-icon icon iconfont icon-amc_circle_close" :title="$t('common.delete')" @click.stop="deleteSource(items.id)" v-g-rac="gRac('dataConfig_delete')"></i>
          <img class="com-box__img" :src="pictureUrl">
          <div class="com-box__title com-box__title--two-line" v-text="items.name" :title="items.name"></div>
        </div>
      </div>
  </div>
</template>
<script>
import rac from '@/plugins/rac-mixin'
import DataConfigBiz from '@/logic/intelligentMonitor/dataConfigBiz'
import { debounce } from '@/utils/tool'
import SiteListBiz from '@/logic/cmdb/cmdbBiz'

export default {
  mixins: [rac],
  components: {
  },

  props: {
    isDelete: {
      type: Boolean,
      default: true
    },
    isAdd: {
      type: Boolean,
      default: true
    }
  },
  data () {
    const that = this
    return {
      form: {
        siteCode: '',
        sourceName: ''
      },
      pictureUrl: require('@/assets/image/datasource.png'), // TODO
      sourceDataAll: [],
      sourceData: [],
      siteList: {},
      searchTimer: null,
      isChose: false,
      doSearch: debounce(that.searchSource, 500)
    }
  },
  watch: {
    'form.sourceName': function (val) {
      this.doSearch(val)
    },
    'form.siteCode': function (val) {
      this.form.sourceName = ''
      this.findSource()
    },
    $route (newV, oldV) {
      if (oldV.name === 'handlerDataConfig') {
        this.getSiteList()
      }
    }
  },
  methods: {
    getSiteList () {
      if (Object.keys(this.siteList).length > 0) {
        this.findSource()
      } else {
        SiteListBiz.siteList({perPageCount: 500}).then((data) => {
          let list = {}
          data.dataList.map((item) => {
            list[item.siteCode] = item.name
          })
          this.siteList = list
          this.form.siteCode = Object.keys(list)[0]
        })
      }
    },
    chooseSource (item, name) {
      this.$emit('data-source-skip', item)
    },
    findSource () {
      this.sourceData = []
      DataConfigBiz.findSourceByName({ siteCode: this.form.siteCode }).then((d) => {
        d.dataList.map((item) => {
          let obj = {}
          if (item.name === 'others') {
            obj.name = this.$t('component.sourceGroupOther')
          } else {
            if (item.list.length > 0) {
              item.list.map((_item) => {
                _item.name = _item.desc
              })
            }
            obj.name = this.$t('component.sourceGroupDefault') + '-' + item.name
          }
          obj.list = item.list
          this.sourceData.push(obj)
        })
        this.sourceDataAll = this.sourceData
      })
    },
    searchSource (name) {
      let list = []
      this.sourceDataAll.map((item) => {
        list.push(this.findNameInList(name, item))
      })
      this.sourceData = list
    },
    findNameInList (name, arr) {
      let obj = {
        name: '',
        list: []
      }
      obj.name = arr.name
      arr.list.map((item) => {
        let itemName = item.name ? item.name : item.desc
        if (itemName.indexOf(name) !== -1) {
          obj.list.push(item)
        }
      })
      return obj
    },
    deleteSource (id) {
      this.$confirm(this.$t('common.deleteTips'), this.$t('common.tips'), {
        type: 'warning'
      }).then(() => {
        DataConfigBiz.deleteSource({
          id: id
        }).then((data) => {
          this.$message({
            message: this.$t('common.success'),
            type: 'success'
          })
          this.findSource()
        })
      }).catch(() => {

      })
    },
    addSource () {
      // TODO
      this.$router.push({ name: 'handlerDataConfig' })
    }
  },
  mounted () {
    this.getSiteList()
  }
}
</script>
